import React from "react";
import PropTypes from "prop-types";
import { Oval } from "react-loader-spinner";
import { useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";

import Input from "components/input";

function EditQualificationsInformation({
  onDiscard = () => {},
  onSave = () => {},
  isLoading = false,
}) {
  const [t] = useTranslation();
  const userDetails = useSelector((state) => state.userDetails || {});

  const defaultsValues = {
    university: userDetails?.extraInformation?.qualifications?.university ?? "",
    qualification:
      userDetails?.extraInformation?.qualifications?.qualification ?? "",
    major: userDetails?.extraInformation?.qualifications?.major ?? "",
  };

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    mode: "onChange",
    defaultValues: defaultsValues,
  });
  return (
    <form
      className="flex flex-col self-stretch rounded-[16px] border-[1px] border-solid border-primary"
      onSubmit={handleSubmit(onSave)}
    >
      <div className="flex p-[24px] justify-between align-center self-stretch border-b border-solid border-[#E4E4E7]">
        <div className="text-[#1D1B22] font-semibold text-[24px]">
          {t("qualifications")}
        </div>

        <div className="flex items-center gap-[12px]">
          <button
            type="button"
            onClick={onDiscard}
            disabled={isLoading}
            className="cursor-pointer flex py-[14px] px-[16px] gap-[8px] justify-center items-center rounded-[6px] border-[1px] border-solid border-default-color bg-white h-[46px]"
          >
            <div className="text-base-black font-bold text-[16px] not-italic">
              {t("Cancel")}
            </div>
          </button>
          <button
            type="submit"
            disabled={isLoading}
            className="cursor-pointer flex py-[14px] px-[16px] gap-[8px] justify-center items-center rounded-[6px] border-[1px] border-solid border-primary bg-primary h-[46px]"
          >
            <Oval
              height={30}
              width={30}
              color="#FFF"
              visible={isLoading}
              ariaLabel="oval-loading"
              secondaryColor="#FFF"
              strokeWidth={5}
              strokeWidthSecondary={3}
            />
            <div className="text-white font-bold text-[16px] not-italic">
              {t("saveChangesCta")}
            </div>
          </button>
        </div>
      </div>

      <div className="flex flex-wrap gap-[20px] p-[24px] self-stretch">
        <div className={``}>
          <div className="flex flex-wrap gap-[20px]">
            <Input
              label={t("university")}
              placeholder={t("placeHolderType", {
                title: t("university").toLowerCase(),
              })}
              name="university"
              register={register}
              registerArgs={{
                required: t("errorField", { field: t("university") }),
              }}
              errorMessage={errors.university ? errors.university.message : ""}
              containerClassName="flex flex-col flex-1 sm-max:grid sm-max:w-full gap-[10px]"
              labelClassName="text-primary font-semibold text-[16px]"
              inputClassName={`flex h-[39px] min-w-[356px] sm-max:w-full items-center gap-[8px] self-stretch rounded-[6px] border-[1px] border-solid ${
                errors.university ? "border-red" : "border-default-color"
              } bg-transparent outline-none text-dark-gray font-regular text-[16px] not-italic  placeholder:font-regular placeholder:text-[16px] placeholder:not-italic placeholder:font-normal py-[16px] px-[14px]`}
            />
            <Input
              label={t("qualification")}
              placeholder={t("placeHolderType", {
                title: t("qualification").toLowerCase(),
              })}
              name="qualification"
              register={register}
              registerArgs={{
                required: t("errorField", { field: t("qualification") }),
              }}
              errorMessage={
                errors.qualification ? errors.qualification.message : ""
              }
              containerClassName="flex flex-col flex-1 sm-max:grid sm-max:w-full gap-[10px]"
              labelClassName="text-primary font-semibold text-[16px]"
              inputClassName={`flex h-[39px] min-w-[356px] sm-max:w-full items-center gap-[8px] self-stretch rounded-[6px] border-[1px] border-solid ${
                errors.qualification ? "border-red" : "border-default-color"
              } bg-transparent outline-none text-dark-gray font-regular text-[16px] not-italic  placeholder:font-regular placeholder:text-[16px] placeholder:not-italic placeholder:font-normal py-[16px] px-[14px]`}
            />

            <Input
              label={t("major")}
              placeholder={t("placeHolderType", {
                title: t("major").toLowerCase(),
              })}
              name="major"
              register={register}
              registerArgs={{
                required: t("errorField", { field: t("major") }),
              }}
              errorMessage={errors.major ? errors.major.message : ""}
              containerClassName="flex flex-col flex-1 sm-max:grid sm-max:w-full gap-[10px]"
              labelClassName="text-primary font-semibold text-[16px]"
              inputClassName={`flex h-[39px] min-w-[356px] sm-max:w-full items-center gap-[8px] self-stretch rounded-[6px] border-[1px] border-solid ${
                errors.major ? "border-red" : "border-default-color"
              } bg-transparent outline-none text-dark-gray font-regular text-[16px] not-italic  placeholder:font-regular placeholder:text-[16px] placeholder:not-italic placeholder:font-normal py-[16px] px-[14px]`}
            />
          </div>
        </div>
      </div>
    </form>
  );
}

EditQualificationsInformation.propTypes = {
  onDiscard: PropTypes.func,
  onSave: PropTypes.func,
  isLoading: PropTypes.bool,
  cvData: PropTypes.object,
};

export default EditQualificationsInformation;
